import { apiClient } from "../../../lib/apiClient"
import type { ApiResponse } from "../../../types/apiResponse";
import type { ChartAccountData } from "../types";

export const editChartAccount = async (body: ChartAccountData) => {
  return apiClient<ApiResponse<null>>('/v1/catalogs/chart_account', {
    method: "PUT",
    body
  });
}
